module.exports = __webpack_public_path__ + "static/media/ITCAVANTGARDESTD-BK.69208cce.ttf";